import { Attribution, Control } from "ol/control";
import "./Attribution.scss";

export class AttributionButton extends Control {
    constructor() {
        super({ element: undefined });
        const attributionControl = new Attribution({
            collapsible: true,
            label: "Autortiesības:",
            collapseLabel: "",
            target: document.getElementsByClassName("bottom-widget-line").item(0) as HTMLElement
        });

        const onClick = (e) => {
            const path = e.composedPath();
            const isAttributionClicked =
                path &&
                !!path.find((p) => {
                    const classes = p.classList && p.classList.length && Array.from(p.classList);
                    return classes && classes.includes("ol-attribution");
                });

            isAttributionClicked && attributionControl.setCollapsed(path && !!path.find((p) => p.tagName === "UL"));
        };

        document.getElementsByClassName("bottom-widget-line").item(0).addEventListener("click", onClick);

        return attributionControl;
    }
}
